module.exports = __webpack_public_path__ + "img/0706-中层云-01.0463e6e3.png";